export default "__VITE_ASSET__Cwf9xWPT__"